import { useNavigate, useLocation, createSearchParams, generatePath } from 'react-router-dom';

import { queryClient, useDeletePostMutation } from 'api';
import { POSTS_REQUEST_LIMIT } from 'constants/index';
import { useModal } from 'hooks';
import { Links } from 'settings';

interface LocationState {
  offset?: string;
}

export function usePostDetailsPageWithoutApiCall(postId: string) {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { isOpen, handleCloseModal, handleOpenModal } = useModal();

  const previousOffset = (state as LocationState)?.offset;

  const offset = previousOffset ? +previousOffset + POSTS_REQUEST_LIMIT : undefined;

  function navigateBack() {
    navigate({
      pathname: Links.we.index,
      search: createSearchParams({
        postId,
        ...(offset && { limit: offset.toString(), offset: '0' }),
      }).toString(),
    });
  }

  const { deletePostMutation } = useDeletePostMutation(() => {
    queryClient.invalidateQueries({ queryKey: ['posts', 'post-details'] });
    navigate(-1);
  });

  async function handleDeletePost() {
    await deletePostMutation({ postId: postId || '' });
    handleCloseModal();
    queryClient.invalidateQueries(['posts']);
    queryClient.invalidateQueries(['post-details']);
  }

  function handleOpenEditMode() {
    const editLink = generatePath(Links.we.posts.edit, { postId: postId ?? '' });
    navigate(editLink);
  }

  return {
    navigateBack,
    isOpen,
    handleDeletePost,
    handleOpenModal,
    handleCloseModal,
    handleOpenEditMode,
  };
}
